module.exports = __webpack_public_path__ + "static/media/water_monitoring_en.c145c17b.png";